import React from 'react';
import { useNavigate } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { adminLocalizationApi, adminLocalizationKeys } from '@/api/admin/localization';
import { Typography, Button, Card } from 'antd';
import { Title } from '@/ui/typography';
import { Container, Flex } from '@/ui/layout';
import { Text } from '@/ui/typography';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export const Localization = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data } = useQuery({
    queryKey: [adminLocalizationKeys.getAllQuestionnaires],
    queryFn: adminLocalizationApi.getAllQuestionnaires,
    select: (data1) => data1.data
  });

  return (
    <Container $paddingY={20}>
      <Container $marginBottom={30}>
        <Title level={3}>{t('Localization')}</Title>
      </Container>

      <RowCards>
        {data &&
          data?.map((quest) => (
            <Card
              key={quest.id}
              size='small'
              title={quest.type}
              style={{ marginBottom: '10px' }}
              styles={{
                header: {
                  fontWeight: 300,
                  fontSize: '14px'
                }
              }}
            >
              <Flex vertical gap={8}>
                {quest.name && <Typography.Text strong>{quest.name}</Typography.Text>}
                <Text $fontSize={14}>{quest.title}</Text>
              </Flex>

              <Container $marginTop={12}>
                <Button
                  mode={'strong'}
                  onClick={() => navigate(`/localization/${quest.id}`)}
                  type='primary'
                >
                  Edit
                </Button>
              </Container>
            </Card>
          ))}
      </RowCards>
    </Container>
  );
};

const RowCards = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
